export default function download (path, filename) {
  const anchor = document.createElement('a')
  anchor.href = path
  anchor.style.display = 'none'
  anchor.download = filename
  document.body.appendChild(anchor)
  anchor.click()
  document.body.removeChild(anchor)
}

export function SaveTxtFile (context, fileName) {
  return new Promise((resolve, reject) => {
    try {
      const blobData = new Blob([context], { type: 'text/plain' })
      const fileReader = new FileReader()
      fileReader.onload = (e) => {
        download(e.target.result, fileName)
        resolve(true)
      }
      fileReader.onerror = (err) => {
        reject(err)
      }
      fileReader.readAsDataURL(blobData)
    } catch (err) {
      reject(err)
    }
  })
}
